import React, { useEffect, useState, useRef } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
interface Parallax3DProps {
  children: React.ReactNode;
  className?: string;
  intensity?: number;
  tiltX?: number;
  tiltY?: number;
  shiftY?: number;
  scaleRange?: [number, number];
}
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768 || 'ontouchstart' in window);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return isMobile;
}
export function Parallax3D({
  children,
  className = '',
  intensity = 1,
  tiltX = 6,
  tiltY = 0,
  shiftY = 40,
  scaleRange = [0.95, 1.05]
}: Parallax3DProps) {
  const isMobile = useIsMobile();
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  const rotateX = useTransform(smoothProgress, [0, 0.5, 1], [tiltX * intensity, 0, -tiltX * intensity]);
  const rotateY = useTransform(smoothProgress, [0, 0.5, 1], [tiltY * intensity, 0, -tiltY * intensity]);
  const y = useTransform(smoothProgress, [0, 0.5, 1], [shiftY * intensity, 0, -shiftY * intensity]);
  const scale = useTransform(smoothProgress, [0, 0.5, 1], [scaleRange[0], 1, scaleRange[1]]);
  // On mobile: skip all parallax transforms, just render children
  if (isMobile) {
    return <div ref={ref} className={className} data-id="element-132">
        <div className="w-full h-full" data-id="element-133">{children}</div>
      </div>;
  }
  return <div ref={ref} className={className} style={{
    perspective: '1000px'
  }} data-id="element-134">
      <motion.div style={{
      rotateX,
      rotateY,
      y,
      scale,
      transformStyle: 'preserve-3d',
      willChange: 'transform'
    }} className="w-full h-full" data-id="element-135">
        {children}
      </motion.div>
    </div>;
}